<template>
    <div>
        <form @submit.prevent="onSubmit" class="stac-form">
            <h2 class="form-title">{{ t('create_account') }}</h2>
            <div v-if="errorMessage" class="callout error">
                {{ errorMessage }}
            </div>
            <div v-if="message" class="callout success">
                {{ message }}
            </div>
            <div v-if="!message" class="grid-y grid-margin-y">
                <div class="field-wrapper">
                    <label for="email">{{ t('email') }}</label>
                    <input type="email" v-model="email" id="email" />
                </div>
                <button type="submit" class="button primary">{{ t('subscribe') }}</button>
            </div>
        </form>
        <div class="agreement-msg" v-html="t('agreement_stac', { external_link: t('a11y.external_link') })"></div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import cms from '@@/js/api/cms';

const { t } = useI18n({
    messages: {
        fr: {
            create_account: "Créer un compte",
            email: "Adresse courriel",
            subscribe: "M'inscrire",
            agreement_stac: "En cliquant sur le bouton « M'inscrire », vous autorisez le STAC à vous envoyer des communications par courriel. En conformité avec la <a href=\"https://www.combattrelepourriel.gc.ca/eic/site/030.nsf/fra/accueil\" target=\"_blank\" rel=\"noopener noreferrer\">Loi canadienne anti-pourriel (C-28)<span class=\"visuallyhidden\"> {external_link}</span></a>, vous pourrez vous désabonner à tout moment grâce à un hyperlien présent dans tous les messages.",
            invalid_email: "Adresse courriel invalide",
        },
        en: {
            create_account: "Create an account",
            email: "Email address",
            subscribe: "Subscribe",
            agreement_stac: "By clicking “Subscribe”, you authorize the STAC to send you communications by email. In accordance with the <a href=\"https://www.combattrelepourriel.gc.ca/eic/site/030.nsf/eng/accueil\" target=\"_blank\" rel=\"noopener noreferrer\">Canadian Anti-Spam Law (C -28)<span class=\"visuallyhidden\"> {external_link}</span></a>, you can unsubscribe at any time using a hyperlink in all messages.",
            invalid_email: "Invalid email address",
        },
    },
});

const email = ref('');
const errorMessage = ref(null);
const message = ref(null);

function onSubmit() {
    errorMessage.value = null;
    message.value = null;
    cms
        .subscribeToNewsletter({
            mail: email.value,
            newsletters: ['stac'],
        })
        .then((response) => {
            message.value = response.message;
        })
        .catch(() => {
            errorMessage.value = t('invalid_email');
        });
}
</script>

<style lang="scss" scoped>
.stac-form {
    background-color: $color-white;
    border-radius: 20px;
    padding: 24px;
    @include breakpoint(medium) {
        padding: 40px;
    }
}
.form-title {
    @include rem-typo(24px);
}
.field-wrapper {
    max-width: 450px;
}
.agreement-msg {
    margin-top: 24px;
}
</style>
